"use client";
import {
  __async
} from "../../../chunk-MMUBH76A.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { CpslButton, CpslText } from "@getpara/react-components";
import { useModalStore, useThemeStore, useUserInfoStore } from "../../stores/index.js";
import { ModalStep } from "../../utils/steps.js";
import { Heading, InnerStepContainer, StepContainer, StyledCpslTileButton } from "../common.js";
import { styled } from "styled-components";
import { useCopyToClipboard } from "@getpara/react-common";
import { getMailtoLink } from "../../utils/getMailtoLink.js";
import { useState } from "react";
const SaveRecoverySecret = ({
  email,
  value,
  onComplete
}) => {
  const [isSecretSaved, setIsSecretSaved] = useState(false);
  const [isCopied, copy] = useCopyToClipboard();
  const onCopy = () => {
    copy(value);
    setIsSecretSaved(true);
  };
  const onDownload = () => {
    const element = document.createElement("a");
    const file = new Blob([value], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = "recovery.txt";
    document.body.appendChild(element);
    element.click();
    setIsSecretSaved(true);
  };
  const onEmail = () => {
    typeof window !== "undefined" && window.open(getMailtoLink(email, value), "_self");
    setIsSecretSaved(true);
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(InnerStepContainer, { children: [
      /* @__PURE__ */ jsx(Heading, { variant: "headingXS", weight: "semiBold", children: "Save your Recovery Secret" }),
      /* @__PURE__ */ jsxs(ButtonContainer, { children: [
        /* @__PURE__ */ jsx(ActionButton, { icon: "download", onClick: onDownload, children: /* @__PURE__ */ jsx(CpslText, { variant: "bodyXS", color: "secondary", weight: "medium", children: "Download" }) }),
        /* @__PURE__ */ jsx(ActionButton, { icon: isCopied ? "check" : "copy", onClick: onCopy, children: /* @__PURE__ */ jsx(CpslText, { variant: "bodyXS", color: "secondary", weight: "medium", children: isCopied ? "Copied!" : "Copy" }) }),
        /* @__PURE__ */ jsx(ActionButton, { icon: "send", onClick: onEmail, children: /* @__PURE__ */ jsx(CpslText, { variant: "bodyXS", color: "secondary", weight: "medium", children: "Email" }) })
      ] })
    ] }),
    /* @__PURE__ */ jsx(InnerStepContainer, { children: /* @__PURE__ */ jsx(CpslButton, { fullWidth: true, onClick: onComplete, disabled: !isSecretSaved, children: !isSecretSaved ? "Choose an option above to continue" : "I\u2019ve saved my recovery secret" }) })
  ] });
};
const RecoverySecretStep = () => {
  const hideWallets = useThemeStore((state) => state.hideWallets);
  const setStep = useModalStore((state) => state.setStep);
  const authInfo = useUserInfoStore((state) => state.getAuthInfo());
  const recoveryShare = useUserInfoStore((state) => state.recoveryShare);
  const backupDecryptionKey = JSON.parse(recoveryShare || "{}").backupDecryptionKey;
  const onComplete = () => __async(void 0, null, function* () {
    setStep(ModalStep.WALLET_CREATION_DONE);
  });
  return /* @__PURE__ */ jsxs(StepContainer, { children: [
    /* @__PURE__ */ jsxs(InnerStepContainer, { children: [
      /* @__PURE__ */ jsx(Heading, { variant: "headingS", weight: "bold", children: hideWallets ? "Don't lose access" : "Don't lose your wallet" }),
      /* @__PURE__ */ jsxs(InlineText, { variant: "bodyS", color: "secondary", weight: "medium", children: [
        "Your",
        " ",
        /* @__PURE__ */ jsx(InlineText, { variant: "bodyS", weight: "medium", children: "Recovery Secret" }),
        " ",
        "ensures you will be able to regain access to your ",
        hideWallets ? "account" : "wallet",
        " if you lose your Passkey or Password."
      ] })
    ] }),
    /* @__PURE__ */ jsx(
      SaveRecoverySecret,
      {
        email: (authInfo == null ? void 0 : authInfo.authType) === "email" ? authInfo.identifier : void 0,
        value: backupDecryptionKey,
        onComplete
      }
    )
  ] });
};
const ActionButton = styled(StyledCpslTileButton)`
  flex: 1;

  --button-icon-color: var(--cpsl-color-text-primary);
`;
const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
`;
const InlineText = styled(CpslText)`
  text-align: center;
  display: inline-block;
`;
export {
  RecoverySecretStep,
  SaveRecoverySecret
};
